import React, { useState } from 'react'
import axios from 'axios';
import baseUrl from "./BaseUrl";
import { useNavigate, Link } from 'react-router-dom';
 
const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [msg, setMsg] = useState('');
    const [isSuccess, setIsSuccess] = useState(false);
    // const [popupOpen, setPopupOpen] = useState(false);  
    // const navigate = useNavigate();
 
    const ChangePassword = async (e) => {
        e.preventDefault();
        try {
            // setPopupOpen(true);
            const resposne = await axios.post(`${baseUrl}/forgot-password`, {
                email: email
            });
            setIsSuccess(true);
            // setPopupOpen(false);
            setMsg(resposne.data.msg);
            // navigate("/login");
        } catch (error) {
            if (error.response) {
                setIsSuccess(false);
                // setPopupOpen(false);
                setMsg(error.response.data.msg);
            }
        }
    }
 
    return (
        <section className="ragister-login loginpage">
            <div className="row d-flex align-items-center">
                <div className="col-md-5 left-box">
                    <div className="inner-slider">

                    </div>
                </div>
                    <div className="col-md-7 right-box">
                        <div className="form-body">
                            <div className="left-logo">
                                <img src={`${process.env.PUBLIC_URL}/images/logo.png`} alt="" />
                            </div>
                            <form onSubmit={ChangePassword} className="form-box login-logo">
                            <p className={`has-text-centered error`}>{msg}</p>
                                <div className="field mt-5">
                                    {/* <label className="label">Email or Username</label> */}
                                    <div className="controls">
                                        <input type="text" className="input" placeholder="Enter your Email" value={email} onChange={(e) => setEmail(e.target.value)} />
                                    </div>
                                </div>
                               
                                <div class="col-12">
                                    <div class="forgot-pass-link"><Link to="/">Back to login</Link></div>
                                </div>
                                <div className="field mt-5 logindiv">
                                    {/* <button className="button is-success is-fullwidth">Login</button> */}
                                    <input type="submit" value="Reset Password"></input>
                                </div>
                            </form>
                        </div>
                    </div>
                
            </div>
        </section>
    )
}
 
export default ForgotPassword
 